import { Injectable } from "@angular/core";
import { DescriptionCard } from "../model/interfaces/description-card";
import { NavigationCard } from "../model/interfaces/navigation-card";

@Injectable( { providedIn: 'root' })
export class ContentService
{
    public descriptionCards: DescriptionCard[] = [
        {
            Title: `Større lod = større gevinster`,
            Description: `Klasselotteriets 5 lodtyper er afgørende for, hvor store dine gevinster kan blive. Spiller du f.eks. på et 1/4-lod, så ejer du kun 1/4 af lodnummeret og vinder 1/4 af gevinsten, når dit lodnummer trækkes.
            Bliver dit nummer trukket med en gevinst på 2 millioner kr., vinder du altså 500.000 kr.* \n
            På et Megalod lægges der til gengæld 50% af gevinsten oveni, så de 2 millioner kr. forhøjes til 3 millioner kr.* \n
            *Hver gevinst over 200 kr. fratrækkes gevinstafgift på 15 % inden udbetaling.`,
            Link: null,
            LinkTitle: null,
            Url: `/support/om-spillet/hvilke-lodtyper-kan-jeg-spille-pa`
        },
        {
            Title: `Flere lodnumre = større vinderchance`,
            Description: `Du kan også øge din chance ved at spille på flere forskellige lodnumre - f.eks. 1/8-lod af ét lodnummer og 1/4-lod af et andet lodnummer. \n
            Ét lodnummer giver dig 41% vinderchance pr. år, mens tallet til sammenligning stiger til hele 88% med fire forskellige lodnumre.`,
            Link: null,
            LinkTitle: null,
            Url: `/support/om-spillet/hvilke-lodtyper-kan-jeg-spille-pa` 
        },
        {
            Title: `Flere lodnumre = større vinderchance`,
            Description: `Det er antallet af forskellige lodnumre og ikke selve lodtypen, der afgør din årlige vinderchance. Med 1 lodnummer har du 41% chance for at vinde minimum 1 gang om året, hvis du spiller med i 12 måneder - og det er ligegyldigt, hvilken lodtype du spiller med (1/8, 1/4, 1/2, 1/1 eller Megalod). Der er en beregnet statistisk sandsynlighed for at vinde, men ikke en garanti. \n
            Nogle gange går der kort tid i mellem, at man vinder - andre gange skal der lidt mere tålmodighed til. Det er en del af spændingen.`,
            Link: null,
            LinkTitle: null,
            Url: `/support/gevinster/hvor-tit-kan-jeg-regne-med-at-vinde`
        },
        {
            Title: `Store gevinster. Stor vinderchance eller begge dele`,
            Description: `Vi kan ikke sige, hvornår du vinder, men vi kan sige, at din chance er større, hvis du har flere forskellige lodnumre. 
            Du kan vælge dine lodder helt som du har lyst til, hvad enten du er til store gevinster, stor vinderchance eller begge dele.`,
            Link: null,
            LinkTitle: null,
            Url: `/support/gevinster/hvor-tit-kan-jeg-regne-med-at-vinde`
        },
        {
            Title: `Prisen afhænger af lodtypen`,
            Description: `I klasselotteriet har du mulighed for at spille på 5 forskellige typer af lodder, og prisen for et lod afhænger af hvilken type lod, du vælger.
            Jo større lod du vælger, jo større bliver såvel din mulige mindste gevinst samt den mulige topgevinst - hvis du er heldig, og dit nummer trækkes.`,
            Link: null,
            LinkTitle: null,
            Url: `/support/kob-og-betaling/hvad-koster-et-lod-i-klasselotteriet`
        },
        {
            Title: `Spil som du har lyst?`,
            Description: `Du kan spille med for kun 20 kr. om måneden. Så har du muligheden for at vinde helt op til 250.000 kr. Du kan også vælge 1/2-lod til 80 kr. pr. måned. Med det kan du vinde helt op til 1 mio. kr. \n
            Ønsker du større vinderchance, skal du have flere forskellige lodnumre. Vælg fx Millionpakken, der giver dig 4 forskellige lodnumre (1 stk. 1/2-lod og 3 stk. 1/4-lodder), en årlig vinderchance på 88% og muligheden for at vinde op til 1 mio. kr. \n
            Hver gevinst over 200 kr. fratrækkes gevinstafgift på 15 % inden udbetaling.`,
            Link: null,
            LinkTitle: null,
            Url: `/support/kob-og-betaling/hvad-koster-et-lod-i-klasselotteriet`
        },
        {
            Title: `Du kan let spille med`,
            Description: `Vælg hvilke lodder, du vil spille på alt efter, om du ønsker mulighed for store gevinster, ønsker større vinderchance eller begge dele.
            Opret dig herefter som kunde, og tilmeld dine lodder til Betalingsservice, så betalingen sker automatisk.`,
            Link: null,
            LinkTitle: null,
            Url: `/support/om-spillet/hvordan-spiller-jeg-med-i-klasselotteriet`
        },
        {
            Title: `Betal 1. måned med betalingskort = hurtigt i gang`,
            Description: `Det kan tage nogle dage at få din tilmelding til Betalingsservice registreret, men hvis du gerne vil hurtigt i gang, kan du betale den første måned med betalingskort. Herefter går det hele automatisk med både betaling af dine lodder og udbetaling af gevinster. 
            Vi krydser fingre for, at du bliver en af de mange glade vindere. 
            `,
            Link: null,
            LinkTitle: null,
            Url: `/support/om-spillet/hvordan-spiller-jeg-med-i-klasselotteriet`
        },
        {
            Title: `52 mio. kr. i gevinstpuljen - hver måned, året rundt`,
            Description: `Der er 5 spændende trækningsdage hver måned fra den 15.-19., hvor du har chancen for at blive en af de mange glade vindere. Der er 11 milliongevinster og 22.046 andre kontante gevinster mellem 1.200 kr. og 250.000 kr.`,
            Link: null,
            LinkTitle: null,
            Url: `/support/gevinster/hvad-vinder-jeg-i-klasselotteriet`
        },
        {
            Title: `Størrelsen på din gevinst afhænger af lodtypen`,
            Description: `Hvor stor DIN gevinst kan blive, afhænger af hvilke lodtyper, du spiller på.
            Eksempler: \n
            Spiller du på et 1/1-lod, skal du ikke dele gevinsten med andre. Du får hele den udtrukne gevinst. \n
            Spiller du på et 1/4-lod, vinder du en 1/4 af gevinsten, når dit lodnummer trækkes. Altså, bliver dit 1/4-lod fx trukket med en gevinst på 2 millioner kr., deles gevinsten ligeligt med ejerne af de resterende dele af lodnummeret. Du vinder dermed 500.000 kr., svarende til en 1/4 af den udtrukne gevinst. \n
            Spiller du på et Megalod, lægges der 50% oveni gevinsten - og du kan med sådan et lod vinde op til 3 mio. kr. \n \n
            Hver gevinst over 200 kr. fratrækkes gevinstafgift på 15 % inden udbetaling.​`,
            Link: null,
            LinkTitle: null,
            Url: `/support/gevinster/hvad-vinder-jeg-i-klasselotteriet`
        },
        {
            Title: `--example--`,
            Description: `Klasselotteriets 5 lodtyper er afgørende for, hvor store dine gevinster kan blive. \n
            Spiller du f.eks. på et 1/4-lod, så ejer du kun 1/4 af lodnummeret og vinder 1/4 af gevinsten, når dit lodnummer trækkes.
            Bliver dit nummer trukket med en gevinst på 2 millioner kr., vinder du altså 500.000 kr. \n
            Har du problemer kan du `,
            Link: `/support/kontakt-os`,
            LinkTitle: `skrive til os her.`,
            Url: `/support/kob-og-betaling/hvad-kostter`
        },
        {
            Title: `--example2--`,
            Description: `Du kan også øge dine chancer ved at spille på flere forskellige lodnumre - f.eks. 1/8-lod af ét lodnummer og 1/4-lod af et andet lodnummer. \n
            Ét lodnummer giver dig 41% vinderchance pr. år, mens tallet til sammenligning stiger til hele 88% med fire forskellige lodnumre. \n
            Du kan altid `,
            Link: `../../../../assets/documents/om-klasselotteriet/generalforsamlinger/referat-af-klasselotteriets-generalforsamling-2019.pdf`,
            LinkTitle: `tjekke om du har vundet i månedens trækning her.`,
            Url: `/support/kob-og-betaling/hvad-kostter`
        },


    ];

    public navigationCards: NavigationCard[] = [
        {
            Title: "Hvilke lodtyper kan jeg spille på?",
            Description: "Klasselotteriets 5 lodtyper er afgørende for, hvor store dine gevinster kan blive.",
            Url: "/support/om-spillet/hvilke-lodtyper-kan-jeg-spille-pa"
        },
        {
            Title: "Hvor tit kan jeg regne med at vinde?",
            Description: "Mange spillere i Klasselotteriet vinder jævnligt, mens andre spiller med i længere tid, før der er gevinst.",
            Url: "/support/gevinster/hvor-tit-kan-jeg-regne-med-at-vinde"
        },
        {
            Title: "Hvad kan jeg vinde?",
            Description: "Du kan få del i en gevinstpulje på 52 mio. kr. – hver måned, året rundt.",
            Url: "/support/gevinster/hvad-vinder-jeg-i-klasselotteriet"
        },
        {
            Title: "Hvordan spiller jeg med?",
            Description: "Vælg din lodtype. Hvor stor din gevinst kan blive, afhænger af loddet.",
            Url: "/support/om-spillet/hvordan-spiller-jeg-med-i-klasselotteriet"
        },
        {
            Title: "Hvad koster et lod?",
            Description: "Prisen afhænger af lodtypen, men du kan spille med fra kun 20 kr.",
            Url: "/support/kob-og-betaling/hvad-koster-et-lod-i-klasselotteriet"
        }
    ]
    
    public constructor()
    {
    }

    public getDescriptionCardContent(): DescriptionCard[]
    {
        return this.descriptionCards;
    }

    public getNavigationCardContent(): NavigationCard[]
    {
        return this.navigationCards;
    }
}
